import landing from './templateLandingPage';

export default {
  init() {
    // JavaScript to be fired on the careers page
    landing.parallaxImage();
    landing.slider();
    landing.appendUTMQueryParamsToCtas();
    landing.playVideoOnScroll();
  },
  finalize() {
    // JavaScript to be fired on the careers page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateCareers.js